import React from 'react';
import { NavActions } from './NavActions';
interface Tab {
  label: string;
  href: string;
  active?: boolean;
}
export interface NavBarProps {
  tabs: Tab[];
  title?: string;
  'data-id'?: string;
}
export function NavBar({
  tabs,
  title = 'Dashboard',
  'data-id': dataId
}: NavBarProps) {
  return <nav className="
        w-full h-16 bg-white border-b border-[#CBD5E1]
        px-6 flex items-center gap-4
      " data-id="element-5625" data-mp="2so8svp1l05uw">



      <h1 className="text-lg font-semibold text-[#0F172A] m-0" data-id="element-5626" data-mp="1vyzveons10y2">{title}</h1>

      <div aria-hidden="true" className="flex-1" data-id="element-5627" data-mp="20w01gzkmm3p6"></div>

      <NavActions data-id="element-5628" data-mp="20uf3t130m4n3" />
    </nav>;
}